export default "__VITE_ASSET__CGTha0B8__"